import { z } from 'zod'

import type { TextContent } from '@flows/core/i18n/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

export const appointmentDetailsSchema = z.object({})
export const appointment_details = (productName: TextContent) => {
  return {
    schema: appointmentDetailsSchema,
    stepContent: [
      {
        type: 'animation',
        width: 140,
        height: 140,
        source: require('@ui-kit/assets/animations/check.json') as string,
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.appointment_details.title',
        },
        size: 'h4',
        fontType: 'primary',
        align: 'center',
      },

      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.appointment_details.subtitle',
        },
        style: 'body1',
        align: 'center',
        emphasis: 'default',
      },
      {
        type: 'list',
        borderColor: 'grey300',
        data: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.date',
              values: { appointmentDate: { type: 'dynamicValue', path: 'appointmentDate' } },
            },
            value: 'appointmentDate',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.time',
              values: { appointmentTime: { type: 'dynamicValue', path: 'appointmentTime' } },
            },
            value: 'appointmentTime',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.appointment_details.product.label',
            },
            value: 'productName',
            // TypeScript complains that productName is not a TextContent because translatableText
            //  is not available in all variants of the TextContent union type.
            // To resolve this, we ensure that productName is explicitly checked before assigning it to textValue.
            ...(productName.type === 'translatableText' ? { textValue: productName } : {}),
          },
        ],
      },
    ],
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: { name: 'getAppointmentDetails', inputs: [], outputs: [] },
    },
    subFlow: SubFlow.Common,
    hideBackButton: true,
    buttonLabel: {
      type: 'translatableText',
      translationKey: 'sharedFlows_common:steps.appointment_details.proceedButtonLabel',
    },
  } as const satisfies AnyStepConfiguration
}
